import React from 'react';
import utils from 'utils';
import MODAL, { MODAL_THEMES, MODAL_BUTTON_TYPES } from 'constants/modals';
import ANALYTICS from 'constants/analytics';
import Modal from 'components/Modal';
import { ModalFooter } from 'components/Modal/ModalFooter';

const { ACCEPT, DECLINE } = MODAL_BUTTON_TYPES;

const LimitedInventoryModal = () => (
  <Modal
    modalKey={MODAL.LIMITED_INVENTORY}
    header={utils.i18n('limited_inventory_modal_title')}
    theme={MODAL_THEMES.WHITE}
    customClass='limited_inventory__modal'
  >
    {({ handleAccept, handleClose, code }) => (
      <>
        <p>{utils.i18n('limited_inventory_modal_content')}</p>
        <ModalFooter
          buttons={[
            {
              type: DECLINE,
              label: utils.i18n('limited_inventory_modal_decline_extra'),
              analyticsValue: ANALYTICS.DO_NOT_ADD,
            },
            {
              type: ACCEPT,
              label: utils.i18n('limited_inventory_modal_accept_extra'),
              handler: () => {
                handleAccept();
                handleClose({
                  analyticsValue: `${ANALYTICS.CONTINUE_ADDING} ${code}`,
                });
              },
            },
          ]}
        />
      </>
    )}
  </Modal>
);

export default LimitedInventoryModal;
